import {
  AuthorizationSSORedirectStorage,
  AuthorizationSSORedirectStore,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'

const STORAGE_KEY = 'sso-redirect-store'

function isAuthorizationSSORedirectStore (store: unknown): store is AuthorizationSSORedirectStore {
  return Boolean(store)
}

export default class AuthorizationSSORedirectStorageImpl implements AuthorizationSSORedirectStorage {

  get (): AuthorizationSSORedirectStore | null {
    const data = localStorage.getItem(STORAGE_KEY)
    if (!data) { return null }
    const store = JSON.parse(data)
    if (isAuthorizationSSORedirectStore(store)) {
      return store
    }
    return null
  }

  set (store: AuthorizationSSORedirectStore) {
    const data = JSON.stringify(store)
    localStorage.setItem(STORAGE_KEY, data)
  }

  clear () {
    localStorage.removeItem(STORAGE_KEY)
  }

}
